<script setup lang="ts">
    type UserRegisterNoSubmitFormProps = {
        submit: () => void;
    };

    const open = ref<boolean>(false);
    const isSuccess = ref(false);
    const showModal = () => open.value = !open.value;
    const { signIn } = useAuth()
    const userRegisterNoSubmitForm = ref<UserRegisterNoSubmitFormProps | null>(null);

    const submit = () => {
        if (userRegisterNoSubmitForm.value && userRegisterNoSubmitForm.value.submit) {
            userRegisterNoSubmitForm.value.submit();
        } else {
            console.error('submit method not found on child component');
        }
    }

    // Handles successful submission
    const handleSuccessEvent = () => {
        isSuccess.value = true;
    }

    // Handles close events
    const handleCloseEvent = () => {
        open.value = false;
        isSuccess.value = false;
    }


    const signInFacebook = async() => {
        await signIn('facebook')
    }

    const signInGoogle = async() => {
        await signIn('google')
    }


    defineExpose({
        open
    })
</script>

<template>
    <button
        type="button"
        @click="showModal"
        class="flex items-center justify-center px-[2rem] text-[1.4rem] leading-[1.5] font-bold rounded-[.8rem] bg-[goldenYellow] hover:bg-[darkYellow] transition ease-in-out delay-150 h-[3.7rem] max-md:py-[.8rem] max-md:px-[1.2rem] max-md:text-[1.2rem]">
        Register
    </button>

    <a-modal 
        :centered="true" 
        :width="750"
        v-model:open="open"
        wrap-class-name="custom-modal"
        @cancel="handleCloseEvent">

        <UserRegisterNoSubmitForm
            v-if="open"
            ref="userRegisterNoSubmitForm"
            @successEvent="handleSuccessEvent"
            @closeEvent="handleCloseEvent"
        />

        <template #footer>
            <Block class="flex flex-col">
                <Block class="mt-[2.4rem] px-[3.6rem] pb-[2rem] flex justify-center gap-[2.4rem] max-md:mt-[1.2rem]" v-if="!isSuccess">
                    <button
                        class="text-[1.4rem] leading-[1.5] font-bold text-[primary] border-[.1rem] border-[darkGray] rounded-[1rem] max-w-[25.2rem] w-full p-[.8rem]"
                        @click="handleCloseEvent">Cancel
                    </button>
        
                    <button
                        class="text-[1.4rem] leading-[1.5] font-bold text-[primary] rounded-[1rem] max-w-[25.2rem] w-full p-[.8rem] bg-[goldenYellow] hover:bg-[darkYellow] transition ease-in-out delay-150"
                        @click="() => submit()">Register
                    </button>
                </Block>
                <Block class="p-4 pb-10 px-[3.6rem]">
                    <a-divider style="height: 1px; background-color: gray; opacity: 50%;" />
                    <p class="text-[secondary] text-[1.4rem] leading-[1.5] text-center">
                        Sign up with
                    </p>
                    <Block class="mt-[1.2rem] flex flex-wrap gap-[.8rem] ">
                            
                            <Block class="flex flex-grow justify-between gap-[0.8rem]">
                                <button 
                                    type="button" 
                                    @click="signInGoogle()" 
                                    class="border-solid border-[.1rem] border-[lightGray] h-[3.7rem] w-full block text-center rounded-[.5rem]">
                                    <span class="google-btn-span">Google</span>
                                </button>
                                <button 
                                    type="button" 
                                    @click="signInFacebook()" 
                                    class="fb-btn w-full text-center h-[3.7rem] rounded-[.5rem] border-solid border-[.1rem] border-[lightGray]">
                                    <span class="fb-btn-span">Facebook</span>
                                </button>
                            </Block>
                    </Block>
                </Block>
            </Block>
        </template>

    </a-modal>
</template>


<style>
.custom-modal .ant-modal-content {
  max-height: 80svh !important;
}
</style>
